import styled from 'styled-components';

export default styled.div<{primaryColor?: string, textColor?: string}>(
  ({theme, primaryColor, textColor}) => `
  --primary-color: ${primaryColor ? primaryColor : '#444CE7'};
  --text-color: ${textColor ? textColor : '#fff'};

  .smartplayer__button {
    width: 48px;
    height: 32px;
    background-color: var(--bg-color);
    border-radius: 4px;
    overflow: hidden;

    &:hover {
      .smartplayer__switchBg {
        background-color: var(--primary-color);
      }

      .smartplayer__switchCbx:checked + .smartplayer__switch {
        background-color: var(--text-color);
      }
    }
  }

  .smartplayer__switchBg {
    z-index: 1;
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    inset: 0;
    background-color: var(--bg-color);
    transition: background-color .3s ease-in-out, filter .3s ease-in-out;
  }

  .smartplayer__summary {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .smartplayer__switchWrapper {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .smartplayer__switch {
    position: relative;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 24px;
    height: 8px;
    pointer-events: none;
    border-radius: 32px;
    z-index: 2;

    background: linear-gradient(to left, rgb(140, 140, 140) 50%, var(--text-color) 50%) right;
    background-size: 200%;
    transition: all .5s ease-in-out;
  }

  .smartplayer__switchCbx {
    opacity: 0;
    visibility: hidden;
    height: 0;
    width: 0;
    position: absolute;
    left: 0;
    top: 0;
  }

  .smartplayer__switchCircle {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    content: "";
    left: 0px;
    height: 14px;
    width: 14px;
    border-radius: 9999px;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(100, 116, 139, 0.325) 0px 3px 10px;
    transition: all 0.3s ease-in-out 0s;
    filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.02)) drop-shadow(-1px 1px 1px rgba(0, 0, 0, 0.02)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.05));
  }

  .smartplayer__switchCbx:checked + .smartplayer__switch {
    background-position: left;

    .smartplayer__switchCircle {
      left: calc(100% - 14px);

      svg {
        color: var(--primary-color);
      }
    }
  }

  .smartplayer__switchCircle svg {
    width: 8px;
    height: 10px;
    color: rgb(140, 140, 140);
    position: absolute;
  }
`);
